import React, { useContext, useEffect, useState } from 'react'
import Header from './Header'
import Output from './output'
import Input from './input'
import { ChatContext } from '~/service/chatConn'
import Side from './Side'
import classNames from 'classnames'
import MiddlewareCommandModal from './modals/MiddlewareCommandModal'
import { MiddlewareCommand } from '~/service/chatConn/types'

const ActiveChat: React.FC = ({}) => {
  const {
    activeChat: chat,
    readMessages,
    scrollOffset,
  } = useContext(ChatContext)
  const [sideActive, setSideActive] = useState(false)
  const [selectedCommand, selectMiddlewareCommand] =
    useState<MiddlewareCommand>()

  useEffect(() => {
    ;(async () => {
      if (document.hidden) {
        await new Promise(r => window.addEventListener('focus', r))

        setTimeout(readMessages, 5000)
      } else {
        if (!scrollOffset) {
          readMessages()
        }
      }
    })()
  }, [chat.messages.length])

  return (
    <div className="chat-activeChat">
      <div
        className={classNames('chat-activeChat-main', {
          'is-side-active': sideActive,
        })}
      >
        <Header
          setSideActive={setSideActive}
          selectMiddlewareCommand={selectMiddlewareCommand}
        />
        <Side />
        <Output />

        {!chat.stopped && <Input scrollAtEnd={false} />}
      </div>

      <Side />

      {selectedCommand && (
        <MiddlewareCommandModal
          command={selectedCommand}
          close={() => selectMiddlewareCommand(undefined)}
        />
      )}
    </div>
  )
}

export default ActiveChat
